var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  ref: "pageFrom",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.pageFrom,
                    "label-position": "right",
                    "label-width": "90px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺名称：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入店铺名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.pageFrom.keywords,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "keywords", $$v)
                            },
                            expression: "pageFrom.keywords",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.search },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: { change: _vm.search },
                          model: {
                            value: _vm.pageFrom.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "status", $$v)
                            },
                            expression: "pageFrom.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "已开业", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "筹备中", value: "0" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已停用", value: "-1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "营业状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: { change: _vm.search },
                          model: {
                            value: _vm.pageFrom.businessStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "businessStatus", $$v)
                            },
                            expression: "pageFrom.businessStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "营业中", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "休息中", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所在地区：" } },
                    [
                      _c("el-cascader", {
                        staticClass: "selWidth",
                        attrs: {
                          clearable: "",
                          options: _vm.areaOptions,
                          props: {
                            value: "id",
                            label: "name",
                            children: "child",
                            checkStrictly: true,
                          },
                          placeholder: "请选择地区",
                        },
                        on: { change: _vm.search },
                        model: {
                          value: _vm.pageFrom.regionId,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "regionId", $$v)
                          },
                          expression: "pageFrom.regionId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.pageFrom.storeTypes,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "storeTypes", $$v)
                            },
                            expression: "pageFrom.storeTypes",
                          },
                        },
                        _vm._l(_vm.storeTypeOptions, function (opt) {
                          return _c("el-option", {
                            key: opt.value,
                            attrs: { label: opt.label, value: opt.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "业务类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.pageFrom.wmTgFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "wmTgFlag", $$v)
                            },
                            expression: "pageFrom.wmTgFlag",
                          },
                        },
                        _vm._l(_vm.wmTgFlagOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search-actions" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.search },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.addStore },
                    },
                    [_vm._v("添加店铺")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.resetSearch },
                    },
                    [_vm._v("重置搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "60" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "店铺LOGO", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "store-logo" }, [
                          scope.row.logo
                            ? _c("img", {
                                staticClass: "logo-img",
                                attrs: { src: scope.row.logo, alt: "店铺LOGO" },
                              })
                            : _c("div", { staticClass: "no-logo" }, [
                                _vm._v("暂无图片"),
                              ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "店铺名称",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantName",
                  label: "所属商户",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeAddress",
                  label: "门店地址",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "店铺状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStoreStatusTagType(
                                scope.row.storeStatus
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.storeStatusName ||
                                    _vm.getStoreStatusText(
                                      scope.row.storeStatus
                                    )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "营业状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.businessStatus === 1
                                  ? "success"
                                  : "warning",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.businessStatus === 1
                                    ? "营业中"
                                    : "休息中"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "当前营业状态", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getCurrentBusinessStatusTagType(
                                scope.row.currentBusinessStatus
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.currentBusinessStatus || "-") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "regionName",
                  label: "所在地区",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "业务类型",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.getWmTgFlagList(scope.row.wmTgFlag).length
                          ? _vm._l(
                              _vm.getWmTgFlagList(scope.row.wmTgFlag),
                              function (item) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: item.value,
                                    staticClass: "wm-tg-tag",
                                    attrs: { type: item.type, size: "small" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.label) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "小票模板",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatTicketTemplateNames(
                                scope.row.ticketTemplateNameList
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "备注",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "数据来源",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.editType === 1 ? "个人创建" : "同步创建"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间", width: "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.editStore(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#f56c6c" },
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteStore(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 50, 100, 200],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("StoreForm", {
        attrs: {
          visible: _vm.storeFormVisible,
          "is-edit": _vm.isEditMode,
          "store-data": _vm.currentStoreData,
          "store-id": _vm.currentStoreId,
          "supplier-options": _vm.merchantOptions,
        },
        on: {
          "update:visible": function ($event) {
            _vm.storeFormVisible = $event
          },
          submit: _vm.handleStoreSubmit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }